/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';
import {
  INITIAL_SERVICE_STATUS,
  LOADING_SERVICE_STATUS,
  LOADED_SERVICE_STATUS,
} from '../../constants/general';

const initialState = {
  companies: [],
  status: INITIAL_SERVICE_STATUS,
};

export const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    fetchCompanies: (state, { payload }) => {
      const filteredCompanies = [];

      payload.forEach((company, index) => {
        if (typeof company.edrpou_inn === 'string' && !!company.edrpou_inn) {
          filteredCompanies.push({ ...company, checked: index === 0 });
        }
      });

      state.companies = filteredCompanies;
    },
    setLoading: (state) => {
      state.status = LOADING_SERVICE_STATUS;
    },
    setLoaded: (state) => {
      state.status = LOADED_SERVICE_STATUS;
    },
    setSelectedCompany: (state, { payload }) => {
      const companiesList = [];

      state.companies.forEach((company) => {
        if (company.checked) {
          company.checked = false;
        }
        if (company.edrpou_inn === payload) {
          company.checked = true;
        }
        companiesList.push(company);
      });

      state.companies = companiesList;
    },
  },
});

export const { fetchCompanies, setLoading, setLoaded, setSelectedCompany } =
  companiesSlice.actions;

export default companiesSlice.reducer;
